import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router';
import { impersonate } from 'redux/modules/auth';

const mapStateToProps = () => ({});

const mapDispatchToProps = {
  impersonate: impersonate.request,
};

export default connect(mapStateToProps, mapDispatchToProps);

export type ConnectedProps = ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

export const useConnect = ({ impersonate }: ConnectedProps) => {
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    if (token) {
      impersonate({ token });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return {
    token,
  };
};
